import { Navigate, useParams } from '@/lib/router'
import PetDemoImage from '@/views/Demos/PetDemoImage'
import { parsePetDemoId } from '@/constants/petDemos'
import { PageSeo } from '@/seo/PageSeo'

export default function PetDemoPage() {
  const { id: raw } = useParams<{ id: string }>()
  const id = raw ? parsePetDemoId(raw) : null

  if (id == null) {
    return <Navigate to="/demos/pets" replace />
  }

  return (
    <>
      <PageSeo path={`/demos/pets/${id}`} />
      <PetDemoImage id={id} />
    </>
  )
}
